import { render, staticRenderFns } from "./folder-add.vue?vue&type=template&id=552b041c&"
import script from "./folder-add.vue?vue&type=script&lang=js&"
export * from "./folder-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552b041c')) {
      api.createRecord('552b041c', component.options)
    } else {
      api.reload('552b041c', component.options)
    }
    module.hot.accept("./folder-add.vue?vue&type=template&id=552b041c&", function () {
      api.rerender('552b041c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/folder-add.vue"
export default component.exports